// removed by extract-text-webpack-plugin
module.exports = {"doc-overlay":"DvrLgj5o5JadnfZ5J792R","docOverlay":"DvrLgj5o5JadnfZ5J792R","top":"_1u6VBt37X0gR9ZXVkse4L8","caption":"_39enjlqba1S18HYIxzJOUR","quelle":"_2SfcGOXnHe4YzM-OFoJT57","text":"_1NjRoYxlpo33CdOTj48tNC","closeButton":"_2FoujXZp3JwezqGpfdhsIg","text-content":"_3Mlc9FaGYxCM0u-zutxoi4","textContent":"_3Mlc9FaGYxCM0u-zutxoi4","header-image":"_1WyshBKa0_ga-8iQE-qgvr","headerImage":"_1WyshBKa0_ga-8iQE-qgvr"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/storydoc/book/overlays/documentOverlay.css
// module id = 393
// module chunks = 0